import { CoinResponse } from "baaanggg"
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    coin: CoinResponse
}

export function TokenCard({ coin }: Props) {
    return <div
        className="relative flex items-center rounded-lg border border-jacarta-100 bg-white p-6 transition-shadow hover:shadow-lg dark:border-transparent dark:hover:border-jacarta-700 dark:bg-gray-900">
        <figure className="mr-5 self-start">
            <img src={resolveImageUrl(coin.icon ?? "/src/img/coins/gold.svg")} alt="avatar 2" className="h-10 w-10 rounded-2lg" loading="lazy" />
        </figure>

        <div>
            <h3 className="mb-1 font-display text-base font-semibold text-jacarta-700 dark:text-white">
                {coin.name}
            </h3>
            <span className="block text-sm text-jacarta-500 dark:text-jacarta-200">{coin.denom ?? coin.cw20Address ?? "-"}</span>
        </div>
    </div>
}